export const Footer = () => {
  return (
    <footer className="py-8 bg-slate-50 border-t" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-slate-500">© 2026 NokMechik. Empowering Women & Girls.</p>
      </div>
    </footer>
  );
};

export default Footer;
